export default __webpack_public_path__ + "static/media/Commercial.b84ff1b1.jpg";